<script setup lang="ts">
/**
 * Form-level error banner above the fields (Figma `66:47222`).
 *
 * Used for failures that belong to the form as a whole rather than one field —
 * chiefly "Incorrect email or password", which stays deliberately vague so the
 * screen never reveals whether the account exists (`66:47510`).
 */
// `Icon/error` at 16px from the banner itself (`66:47232`) — the shared `error`
// icon is a 12px toast glyph on a different grid.
import errorIconUrl from '@/features/auth/ui/icons/error.svg'

defineProps<{ message: string }>()
</script>

<template>
  <div
    class="fair-auth-banner"
    role="alert"
  >
    <img
      class="fair-auth-banner__icon"
      :src="errorIconUrl"
      alt=""
    >
    <span>{{ message }}</span>
  </div>
</template>
